import { render, staticRenderFns } from "./SloughCity.vue?vue&type=template&id=1ba94d2f&scoped=true&"
import script from "./SloughCity.vue?vue&type=script&lang=js&"
export * from "./SloughCity.vue?vue&type=script&lang=js&"
import style0 from "./SloughCity.vue?vue&type=style&index=0&id=1ba94d2f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba94d2f",
  null
  
)

export default component.exports